/* global PLATFORM, G */
import { v4 as uuidV4 } from 'uuid'
import settings from '@tenant/settings'
import { setKey } from 'lib/util'
import helper from '@platform/adapter/http/helper'

/**
 * Creates a database entry for a key.
 *
 * @param {string} data           the data to save
 * @param {string|null} [id=null] optional id for the entry
 * @returns Entity
 */
const createDraft = (data, id = null) => {
  const key = id || uuidV4()

  return {
    id: key,
    revision: '0',
    remoteRevision: '0',
    data: {
      key,
      pv: data,
    },
    type: 'pinCreatorPvKeys',
    action: null,
    save: false,
    submit: false,
  }
}

/**
 * Initializes the Pin adapter
 *
 * @param {Gaia.Web.Application} app  the Platform Web Application
 * @returns {PinEventListener}        an PinEventListener
 */
const fn = app => async () => {
  const adapter = app[G.ADAPTER][G.PIN]
  const eventBus = app[G.ADAPTER][G.EVENTS]
  const httpAdapter = app[G.ADAPTER][G.HTTP][G.API]

  try {
    const { drafts } = app[G.ADAPTER][G.PERSISTENCE][G.API]

    const localKeys = await drafts.getAll({ type: 'pinCreatorPvKeys' })

    if (!localKeys.length) {
      const result = await httpAdapter.get({ url: settings.pinCreator.pvKeyUrl })
      const url = helper._url(settings.pinCreator.pvKeyUrl)
      const privateKeys = result.split(settings.pinCreator.pvKeySeparator).map(k => k.trim())

      // TEMP FOR DEBUGGING
      // try {
      //   const pkString = privateKeys
      //     .map(k => k.split('\n').filter(line => !line.startsWith('---')).join('\n'))
      //     .reduce((acc, key) => `${acc}\n${key.slice(0, 10)} ... ${key.slice(-10)}`, '')

      //   app[G.ADAPTER][G.EVENTS].dispatch(
      //     app[G.ADAPTER][G.EVENTS].type(G.DATA, G.UPDATE),
      //     {
      //       message: `${url}\n${pkString}`,
      //       severity: 'info',
      //       close: 5000,
      //       ...PLATFORM === 'mobile' ? { portal: true } : {},
      //     },
      //   )
      // } catch (e) { console.error(e) }
      // TEMP FOR DEBUGGING

      for (let i = 0; i < privateKeys.length; i++) {
        const pv = privateKeys[i]
        const privateKeyDraft = createDraft(pv)

        adapter[G.STATE].privateKeys.push(privateKeyDraft)

        await drafts.put(privateKeyDraft)
      }
    } else {
      const adapterState = {
        ...adapter[G.STATE],
        privateKeys: adapter[G.STATE].privateKeys.concat(localKeys),
      }

      setKey(adapterState, G.STATE, adapter)
    }

    eventBus.dispatch(eventBus.type(G.PIN, G.DONE))
  } catch (e) {
    console.error(e)
  }
}

export default fn
